<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <table #dataTable class="display" style="width:100%"></table>

        <button type="button" id="btn_AddNew" (click)="show()" style="display:none">Add</button>
        <button type="button" id="btnDeleteDT" (click)="delete()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="deleteConfirm()" style="display:none">Delete Confirm</button>
        <button type="button" id="btnUpdateScheduleDate" (click)="updateScheduleDate()" style="display:none">Update Schedule Date</button>
        <button type="button" id="btnUpdateCompletedDate" (click)="updateCompletedDate()" style="display:none">Update Completed Date</button>
        <button type="button" id="btnRevisedScheduleDate" (click)="revisedScheduleUpdatedList()" style="display:none">Update Revised Date</button>

        <div id="" class="modal myModalView" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <div class="row" id="bookInfo" style="padding-top:10px">
                    <div class="col-sm-4">
                      <table class="tblBkinfo tblMain table table-bordered" width="100%" id="">
                        <tbody>
                          <tr>
                            <td>Article No</td>
                            <td>{{articleNo}}</td>
                          </tr>
                          <tr>
                            <td>DOI</td>
                            <td>{{doi}}</td>
                          </tr>
                          <tr>
                            <td>Received date</td>
                            <td>{{receivedDate}}</td>
                          </tr>
                          <tr>
                            <td>Due date</td>
                            <td>{{dueDate}}</td>
                          </tr>
                          <tr>
                            <td>TAT Details</td>
                            <td>{{tatDetails}}</td>
                          </tr>
                          <tr>
                            <td>Authors</td>
                            <td>{{authors}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="col-sm-12">
                        <br>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td>
                                <div class="divGreen">
                                  Ahead
                                </div>
                              </td>
                              <td>
                                <div class="divOnime">
                                  On-time
                                </div>
                              </td>
                              <td>
                                <div class="divOverDue">
                                  Overdue
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-sm-8">
                      <div id="DivActivityList_Plan" style="overflow:auto">
                        <table id='tblProjectPlanInfo' class='tblTrans table table-bordered'>
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>Activity</th>
                              <!--<th>%</th>-->
                              <th>Days</th>
                              <th>ScheduleDate</th>
                              <th>Day</th>
                              <th>Revised Schedule Date</th>
                              <th>Completed Date</th>
                            </tr>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" title="Close" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="updateProjectPlan()">{{popUpButtonText}}</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
